import { RedditEvidenceCard } from "@/app/(site)/[lang]/[reportType]/explore/_components/reddit-evidence-card";
import { parseRedditSourceId } from "../../application/sources/reddit-source-id";
import type {
  DiscoverClientSource,
  DiscoverEvidenceBlock,
  DiscoverNoteSource,
} from "../shared/source-contract";
import { RedditNoteSourceCard } from "./reddit-note-source-card";

export const redditClientSource = {
  id: "reddit",
  matches({
    metadata,
    sourceId,
    sourceType,
  }: {
    sourceType: string;
    sourceId: string;
    metadata: Record<string, unknown>;
  }) {
    if (sourceType.toUpperCase() === "REDDIT") {
      return true;
    }

    return (
      metadata.provider === "reddit" ||
      parseRedditSourceId({ sourceId }) !== null
    );
  },
  resolveAppendixIdentity({
    sourceId,
    sourceType,
  }: {
    sourceType: string;
    sourceId: string;
    metadata: Record<string, unknown>;
  }) {
    if (sourceType.toUpperCase() !== "REDDIT") {
      return null;
    }

    const identity = parseRedditSourceId({ sourceId });
    if (!identity) {
      return null;
    }

    return {
      groupKey: identity.postId,
      variantKey: "post",
    };
  },
  renderEvidence({
    block,
    key,
  }: {
    block: DiscoverEvidenceBlock;
    key: string;
  }) {
    return (
      <RedditEvidenceCard
        key={key}
        metadata={block.metadata}
        title={block.title}
        url={block.url}
      />
    );
  },
  renderNoteSource({
    note,
  }: {
    exploreBase: string;
    note: DiscoverNoteSource;
    onOpenChange: (open: boolean) => void;
  }) {
    return <RedditNoteSourceCard note={note} />;
  },
} satisfies DiscoverClientSource;
